import React from "react"

import classNames from "classnames"

import { ContentTag } from "scrivito"

import { LogoSlider } from "widgets/logo-slider/LogoSlider"

import { LogoSliderWidgetInstance } from "../LogoSliderWidgetClass"

export function LogoSliderWidgetView({
  widget
}: {
  widget: LogoSliderWidgetInstance
}) {
  return (
    <section className={classNames("logo-slider-widget")}>
      <div className="logo-slider-widget__header">
        <ContentTag
          className="logo-slider-widget__title"
          content={widget}
          attribute="title"
        />
        <ContentTag
          className="logo-slider-widget__subtitle"
          content={widget}
          attribute="subtitle"
        />
      </div>

      <LogoSlider logoCount={widget.get("logos").length ?? 0}>
        <ContentTag
          className="logo-slider-widget__logos"
          content={widget}
          attribute="logos"
        />
      </LogoSlider>
    </section>
  )
}
